import { useState, useEffect } from 'react';

/**
 * Custom hook that returns true only after the component has mounted on the client side.
 * This helps prevent hydration mismatches between server and client rendering.
 */
export function useClientMount() {
    const [hasMounted, setHasMounted] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, []);

    return hasMounted;
}
